var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"liveReplay"}},[_c('div',{staticClass:"container"},[_c('video',{ref:"myVideo",staticClass:"video",attrs:{"src":_vm.media_url,"autoplay":"true","controls":"controls"},on:{"click":_vm.changePlay}},[_c('source',{attrs:{"src":_vm.media_url,"type":"video/mp4"}}),_vm._v("\n      您的浏览器不支持Video标签。\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f2b86a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/qcwy/liveReplay.vue
// module id = null
// module chunks = 